export const flexpass = (item, client) => {
    return `<?xml version="1.0" encoding="utf-8"?>
    <DieCutLabel Version="8.0" Units="twips">
    <PaperOrientation>Landscape</PaperOrientation>
    <Id>LargeLeverArch99019</Id>
    <PaperName>99019 Large Lever Arch</PaperName>
    <DrawCommands>
        <Rectangle X="0" Y="0" Width="3329" Height="10771"/>
    </DrawCommands>
    <ObjectInfo>
        <TextObject>
        <Name>FLEXPASSCLIENT</Name>
        <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
        <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
        <LinkedObjectName></LinkedObjectName>
        <Rotation>Rotation0</Rotation>
        <IsMirrored>False</IsMirrored>
        <IsVariable>False</IsVariable>
        <HorizontalAlignment>Center</HorizontalAlignment>
        <VerticalAlignment>Top</VerticalAlignment>
        <TextFitMode>None</TextFitMode>
        <UseFullFontHeight>True</UseFullFontHeight>
        <Verticalized>False</Verticalized>
        <StyledText>
            <Element>
            <String>Your Flex Pass for ${client.client_name}</String>
            <Attributes>
                <Font Family="Arial" Size="18" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
            </Attributes>
            </Element>
        </StyledText>
        </TextObject>
        <Bounds X="1507" Y="381.0043" Width="8066" Height="537.8085"/>
    </ObjectInfo>
    <ObjectInfo>
        <TextObject>
        <Name>FLEXPASSNAME</Name>
        <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
        <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
        <LinkedObjectName></LinkedObjectName>
        <Rotation>Rotation0</Rotation>
        <IsMirrored>False</IsMirrored>
        <IsVariable>False</IsVariable>
        <HorizontalAlignment>Center</HorizontalAlignment>
        <VerticalAlignment>Top</VerticalAlignment>
        <TextFitMode>None</TextFitMode>
        <UseFullFontHeight>True</UseFullFontHeight>
        <Verticalized>False</Verticalized>
        <StyledText>
            <Element>
            <String>${item.name}</String>
            <Attributes>
                <Font Family="Arial" Size="18" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
            </Attributes>
            </Element>
        </StyledText>
        </TextObject>
        <Bounds X="1507" Y="790.6695" Width="8066" Height="537.8085"/>
    </ObjectInfo>
    <ObjectInfo>
        <TextObject>
        <Name>DISCLAIMER</Name>
        <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
        <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
        <LinkedObjectName></LinkedObjectName>
        <Rotation>Rotation0</Rotation>
        <IsMirrored>False</IsMirrored>
        <IsVariable>False</IsVariable>
        <HorizontalAlignment>Center</HorizontalAlignment>
        <VerticalAlignment>Top</VerticalAlignment>
        <TextFitMode>AlwaysFit</TextFitMode>
        <UseFullFontHeight>True</UseFullFontHeight>
        <Verticalized>False</Verticalized>
        <StyledText>
            <Element>
                <String>Thank you for purchasing a Flex Pass! PLEASE BE SURE TO KEEP THIS TICKET.\n</String>
                <Attributes>
                    <Font Family="Arial" Size="11" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
                </Attributes>
            </Element>
            <Element>
                <String>When you are ready to purchase your individual tickets, please use the code below during the purchase process.\n</String>
                <Attributes>
                    <Font Family="Arial" Size="11" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
                </Attributes>
            </Element>
            <Element>
                <String>You do not have to redeem all your tickets at once. Some events may be restricted from use with Flex Passes.</String>
                <Attributes>
                    <Font Family="Arial" Size="11" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
                </Attributes>
            </Element>
        </StyledText>
        </TextObject>
        <Bounds X="1507" Y="1312.81" Width="8066" Height="537.8085"/>
    </ObjectInfo>
    <ObjectInfo>
        <TextObject>
        <Name>FLEXPASSNUMBEROFTICKETS</Name>
        <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
        <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
        <LinkedObjectName></LinkedObjectName>
        <Rotation>Rotation0</Rotation>
        <IsMirrored>False</IsMirrored>
        <IsVariable>False</IsVariable>
        <HorizontalAlignment>Center</HorizontalAlignment>
        <VerticalAlignment>Top</VerticalAlignment>
        <TextFitMode>None</TextFitMode>
        <UseFullFontHeight>True</UseFullFontHeight>
        <Verticalized>False</Verticalized>
        <StyledText>
            <Element>
            <String>This Flex Pass is worth ${item.max_tickets} tickets.</String>
            <Attributes>
                <Font Family="Arial" Size="11" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
            </Attributes>
            </Element>
        </StyledText>
        </TextObject>
        <Bounds X="1507" Y="1812.81" Width="8066" Height="537.8085"/>
    </ObjectInfo>
    <ObjectInfo>
        <TextObject>
        <Name>FLEXPASSCODE</Name>
        <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
        <BackColor Alpha="0" Red="255" Green="255" Blue="255"/>
        <LinkedObjectName></LinkedObjectName>
        <Rotation>Rotation0</Rotation>
        <IsMirrored>False</IsMirrored>
        <IsVariable>False</IsVariable>
        <HorizontalAlignment>Center</HorizontalAlignment>
        <VerticalAlignment>Top</VerticalAlignment>
        <TextFitMode>None</TextFitMode>
        <UseFullFontHeight>True</UseFullFontHeight>
        <Verticalized>False</Verticalized>
        <StyledText>
            <Element>
            <String>Code: ${item.code}</String>
            <Attributes>
                <Font Family="Arial" Size="20" Bold="True" Italic="False" Underline="False" Strikeout="False"/>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0"/>
            </Attributes>
            </Element>
        </StyledText>
        </TextObject>
        <Bounds X="1507" Y="2112.81" Width="8066" Height="537.8085"/>
    </ObjectInfo>
    </DieCutLabel>`
}



// WEBPACK FOOTER //
// ./src/lib/labels/ShowTix4UFlexpass.js